import { Controller } from "@hotwired/stimulus"
import SlimSelect from "slim-select";
import 'slim-select/styles' // optional css import method

export default class extends Controller {
  private slimSelect: SlimSelect | null = null;

  connect() {
    this.slimSelect = new SlimSelect({
      select: this.element,
    })

    // Remove the main class and arrow element since no way to do it with settings
    document.getElementsByClassName("ss-arrow")[0].remove();
    (document.getElementsByClassName("ss-main")[0] as HTMLElement).style.display = "flex";

  }

  disconnect() {
    this.slimSelect?.destroy();
    this.slimSelect = null;
  }
}
